export default __webpack_public_path__ + "98320afbc3618eda721b3bd461fa82d3.svg";